$(document).ready(function () {
  var isAnnouncement = localStorage.getItem('isAnnouncement');
  const $addToCartTextSpan = $('[data-dynamic-add-to-cart-text]')
  const $leadTimeMessaging = $('[data-lead-time-messaging]')
  const $lineItemPropertyLeadTimeMsg = $('[data-line-item-property-lead-time-msg]')
  // const $lineItemPropertyShortLeadTimeMsg = $('[data-line-item-property-short-lead-time-msg]') // uncomment when upgraded to shopify+ to display in the checkout
  const $addToCartButton = $('[data-add-to-cart]')

  if(isAnnouncement != "yes") {
    $(".sqs-announcement-bar-text").removeClass("hide");
  }
  $(".side_bar_button").click(function () {
    $(this).toggleClass("is_active");
    $(this).next().slideToggle();
  });
  $("#BtnMobileMenu").click(function() {
    $(".mobile-nav-wrapper").addClass("is--active");
    $('body').css('overflow', 'hidden');
  });
  $(".mobile-menu-close").click(function() {
    $(".mobile-nav-wrapper").removeClass("is--active");
    $('body').css('overflow', 'auto');
  });
  // Zoom plugin
  // $('.ik-product-zoom-image').imageZoom();
  $('.ik-image-zoom').each(function(){
		$(this).imageZoom();
	});
  // Announcement Bar
  $(".sqs-announcement-bar-close").click(function() {
    localStorage.setItem('isAnnouncement', "yes");
    $(".sqs-announcement-bar-text").addClass("hide");
  });

  
  // Product Page
  const singleOptionSelector = $('.single-option-selector')

  displaySelectedSwatchNames()

  
  $("#product-quantity-selector").on('change', togglePurchaseState );
  // event listener for when the user types in the quantity input
  $("#product-quantity-selector").on('keyup', togglePurchaseState );

  singleOptionSelector.on('change', function() {  
    displaySelectedSwatchNames()   
    // why is this needed? 
    // need to fix so the page isn't flashing
    
    document.location.reload()
  })
  
  try { 
    // is this try and catch needed? template-product element is no where to be found on the page
    if ($('.template-product').length){
	    
      togglePurchaseState()
    }
  } catch(e) {
  	console.log(e)
  }


  function updateLeadTimeText(longText, shortText) {
    $leadTimeMessaging.text(longText)
    $lineItemPropertyLeadTimeMsg.val(longText)
    // $lineItemPropertyShortLeadTimeMsg.val(shortText ? shortText : longText) // uncomment when upgraded to shopify+ to display in the checkout
  }

  // custom functions   
  function togglePurchaseState(e) {
    const numSelected = parseInt(e ? e.target.value : 1);
    
    const onOrderQuantity = __currentVariantAvailMetafields.OnOrderQuantity ? __currentVariantAvailMetafields.OnOrderQuantity : 0    
    let estimatedAvailableDate = __currentVariantAvailMetafields.EstimatedAvailableDate ? __currentVariantAvailMetafields.EstimatedAvailableDate : null
    const sumOfOnOrderAndInStockQtn = onOrderQuantity + __currentProductInventory
    let isOverInventoryLimit = false
    
    if (__continueSellingWhenOutOfStock == 'deny' ) {
      isOverInventoryLimit = isOutOfStock(numSelected, __currentProductInventory)      
    }
    
    if (isOverInventoryLimit) {
      $addToCartTextSpan.text(__quantityUnavailableMessage)

      // updating lead time
      updateLeadTimeText(__quantityUnavailableLeadTimeText)
      toggleAddToCartBtn(false)
      return
    } else {
      toggleAddToCartBtn(true)
    }
    
    if (!estimatedAvailableDate || estimatedAvailableDate === '12/31/9999' || estimatedAvailableDate === '9999-12-31') {
      estimatedAvailableDate = null
    }
      
    if (numSelected <= __currentProductInventory) {   
      // product is in stock
      $addToCartTextSpan.text(__inStockBtnText)
      $addToCartButton.attr('aria-label', __inStockBtnText);
      updateLeadTimeText(__inStockLeadTimeText, __inStockLeadTimeTextShort)

    } else if (sumOfOnOrderAndInStockQtn >= numSelected && estimatedAvailableDate) {

      const availableDate = new Date(estimatedAvailableDate).toLocaleDateString('en-US', { timeZone: 'UTC', month: 'long', day: 'numeric', year: 'numeric' })    
      // desired quantity is less than the sum of the quantity in stock and on order
      // displays on order text
      const leadTimeText = __onOrderLeadTimeText.replace('{{ EstimatedAvailableDate }}', availableDate)
      const shortLeadTimeText = __onOrderLeadTimeTextShort.replace('{{ EstimatedAvailableDate }}', availableDate)
      $addToCartTextSpan.text(__onOrderBtnText)
      $addToCartButton.attr('aria-label', __onOrderBtnText);

      updateLeadTimeText(leadTimeText, shortLeadTimeText)
    } else if (__currentProductInventory < numSelected && sumOfOnOrderAndInStockQtn < numSelected) {      
      // desired quantity is larger than the current product inventory, and desired quantity is greater than the sum of the quantity in stock and on order
      // displays MTO text
      const leadTimeText = __mtoLeadTimeText.replace('{{ quantity }}', numSelected)
      const leadTimeTextShort = __mtoLeadTimeTextShort.replace('{{ quantity }}', numSelected)
      $addToCartTextSpan.text(__mtoBtnText)
      $addToCartButton.attr('aria-label', __mtoBtnText);
      updateLeadTimeText(leadTimeText, leadTimeTextShort)

    }
  }

  function toggleAddToCartBtn(isEnabled) {
    if (isEnabled) {      
      $addToCartButton.removeAttr('aria-disabled');
    } else {      
      $addToCartButton.attr('aria-disabled', true);      
      $addToCartButton.attr('aria-label', __quantityUnavailableMessage);
    }
  }

  function isOutOfStock(numSelected, currentProductInventory) {
    // return true if the quantity selected is greater than the current product inventory
    return numSelected > currentProductInventory ? true : false
  }


  function displaySelectedSwatchNames() {
    const selectedSwatchLabels = $('[js-data="selectedSwatchLabel"]')
    const selectedSwatchInputs = $('[js-data="swatchInput"]:checked')
    
    
    updateSelectedSwatchName(selectedSwatchLabels, selectedSwatchInputs)
  }
  
  function updateSelectedSwatchName($selectedSwatchLabels, $selectedSwatchInputs)  {
    $selectedSwatchLabels.each((index, label) => {
      const $selectedInputValue = $($selectedSwatchInputs[index]).attr('value')
      
      $(label).text($selectedInputValue)      
    })
    
  }
})
